import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-the-header-navi-on-general" }
const _hoisted_2 = { class: "p-the-header-navi-on-general__drawer__body" }
const _hoisted_3 = { class: "p-the-header-navi-on-general__prev__icon" }
const _hoisted_4 = { class: "p-the-header-navi-on-general__prev__text" }
const _hoisted_5 = {
  ref: "navi",
  class: "p-the-header-navi-on-general__drawer__navi"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft3sticks = _resolveComponent("IconArrowLeft3sticks")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_TheHeaderNaviOfUserMenu = _resolveComponent("TheHeaderNaviOfUserMenu")!
  const _component_TheHeaderNaviOfCategoryMenu = _resolveComponent("TheHeaderNaviOfCategoryMenu")!
  const _component_TheHeaderNaviOfSubMenu = _resolveComponent("TheHeaderNaviOfSubMenu")!
  const _component_TheHeaderNaviOfOtherMenu = _resolveComponent("TheHeaderNaviOfOtherMenu")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.pager.hierarchy > 0 && _ctx.pager.text)
        ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "p-the-header-navi-on-general__prev",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.setChildItemObject(
            {
              key: -1,
              children: true,
              refsName: 'categoryNavi',
              pagerObj: {
                hierarchy: -1,
                text: 'メインメニュー'
              }
            },
            false
          )
        ))
          }, [
            _createElementVNode("i", _hoisted_3, [
              _createVNode(_component_IconBase, {
                width: 24,
                height: 24,
                "view-box": "0 0 24 24",
                "icon-color": "#000000"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconArrowLeft3sticks)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.pager.text), 1)
          ])), [
            [_directive_touch, void 0, "tap"]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_TheHeaderNaviOfUserMenu, {
          class: "p-the-header-navi-on-general__navi",
          point: _ctx.point,
          unit: _ctx.unit,
          "icon-color": _ctx.iconColor,
          "whats-new-unread-count": _ctx.whatsNewUnreadCount,
          "thanks-point-unread-count": _ctx.thanksPointUnreadCount
        }, null, 8, ["point", "unit", "icon-color", "whats-new-unread-count", "thanks-point-unread-count"]),
        false
          ? (_openBlock(), _createBlock(_component_TheHeaderNaviOfSubMenu, {
              key: 0,
              class: "p-the-header-navi-on-general__navi p-the-header-navi-on-general__navi--service",
              "icon-color": _ctx.iconColor
            }, {
              category: _withCtx(() => [
                _createVNode(_component_TheHeaderNaviOfCategoryMenu, {
                  pager: _ctx.pager,
                  "onUpdate:pager": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pager) = $event)),
                  shown: _ctx.shown,
                  "onUpdate:shown": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shown) = $event)),
                  "data-of-pager-before-formatting": 
                _ctx.dataOfPagerBeforeFormatting
              ,
                  "onUpdate:dataOfPagerBeforeFormatting": _cache[3] || (_cache[3] = ($event: any) => ((
                _ctx.dataOfPagerBeforeFormatting
              ) = $event)),
                  "icon-color": _ctx.iconColor,
                  onAnimationChildItem: _ctx.animationChildItem
                }, null, 8, ["pager", "shown", "data-of-pager-before-formatting", "icon-color", "onAnimationChildItem"])
              ]),
              _: 1
            }, 8, ["icon-color"]))
          : _createCommentVNode("", true),
        _createVNode(_component_TheHeaderNaviOfOtherMenu, {
          class: "p-the-header-navi-on-general__navi p-the-header-navi-on-general__navi--other",
          "icon-color": _ctx.iconColor
        }, null, 8, ["icon-color"])
      ], 512)
    ])
  ]))
}